<template>
  <div class="specifictradelaw section">
    <div class="columns">
      <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
        <h1 class="subtitle">特定商取引法に基づく表記</h1>
        <p class="block">１.販売業者<br>
        株式会社シトラスウインズ</p>
        <p class="block">２.代表者名<br>
        代表取締役社長  高木 杏子</p>
        <p class="block">３.所在地<br>
        東京都渋谷区神宮前6丁目23-4 桑野ビル2F</p>
        <p class="block">４.お問い合わせ先<br>
        Email:info_elkatsu@citruswinds.co.jp<br>
      ※原則としてお電話でのお問い合わせは受け付けておりませんので、メールにてお問い合わせください。</p>
        <p class="block">５.販売価格<br>
        購入手続きの際に画面に表示されます。消費税は、内税として表示しております。</p>
        <p class="block">６.販売価格以外で必要となる料金<br>
        ウェブページの閲覧、デジタルコンテンツやソフトウェアのダウンロード等に必要となるインターネット接続料金、通信料金等はお客様の負担となります。それぞれの料金は、お客様がご利用のインターネットプロバイダーまたは携帯電話会社にお問い合わせください。</p>
        <p class="block">７.デジタルコンテンツ等が利用可能となる時期<br>
        購入に関するページに特別な定めを置いている場合を除き、購入手続の完了後、直ちに提供いたします。</p>
        <p class="block">８.代金のお支払時期・方法<br>
        ＜お支払方法＞<br>デジタルコンテンツ等の購入手続時に、以下の方法によりお支払いただきます。<br>クレジットカード決済<br><br>
        ＜お支払時期＞<br>
      購入手続時</p>
        <p class="block">９.返品について<br>
        コンテンツの返品及び交換は出来ないものとします。</p>
        <p class="block">10.推奨環境<br>
        Windows を利用する場合<br>
        &emsp;Windows10 以降<br>
        &emsp;Chrome 64 以降<br>
        &emsp;Edge 79 以降<br>
        Mac OS を利用する場合<br>
        &emsp;Chrome 64 以降<br>
        &emsp;Safari 11 以降<br>
        Android を利用する場合<br>
        &emsp;Chrome 64 以降<br>
        iOS を利用する場合<br>
        &emsp;Safari 11 以降<br>
        &emsp;Chrome 64 以降</p>
        <!-- <div class="content">
          <ul>
            <li>リストリスト</li>
            <li>リストリスト</li>
            <li>リストリスト</li>
          </ul>
          <ol>
            <li>番号付きリストリスト</li>
            <li>番号付きリストリスト</li>
            <li>番号付きリストリスト</li>
          </ol>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpecificTradeLaw'
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/specific-trade-law.scss';
</style>
